import { render, staticRenderFns } from "./PageBgContent.vue?vue&type=template&id=62de55aa&scoped=true"
import script from "./PageBgContent.vue?vue&type=script&lang=js"
export * from "./PageBgContent.vue?vue&type=script&lang=js"
import style0 from "./PageBgContent.vue?vue&type=style&index=0&id=62de55aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62de55aa",
  null
  
)

export default component.exports